module.exports = "/_next/static/images/a1c12f417df85cdc16921fb5abee8dc2-device-frame@0.5x.png";